module.exports = __webpack_public_path__ + "img/open-book-b.f3ececb8.svg";